<template>
  <div class="wrapper wrapper-running-date">
    <Progress @back="goToStep(7)" />
    <DateField :name="name" error="Нужно указать дату забега" @submit="setValue">
      <template v-slot:Title>Укажи дату забега:</template>
    </DateField>
  </div>
</template>

<script>
  import DateField from '@/components/DateField'
  import Progress from '@/components/Progress'
  export default {
    name: 'Step_5',
    data() {
      return {
        name: 'date',
        variants: [
          {
            key: 1,
            title: 'Да'
          },
          {
            key: 2,
            title: 'Нет'
          },
        ]
      }
    },
    components: {
      Progress,
      DateField,
    },
    computed: {
      step() {
        return this.$store.state.step;
      }
    },
    methods: {
      goToStep(value) {
        this.$store.dispatch('setStepBack', value);
        this.$router.push({ path: '/', query: {step: this.step}});
      },
      setValue(value) {
        let stepData = {
          id: 9,
          title: 'Дата забега',
          answerText: value,
          answer: value,
        }
        this.$store.dispatch('setValue', stepData);
        this.$router.push('/register');
      }
    }
  }
</script>

<style>
  .center-date {
    text-align: center;
    padding-left: 0;
    padding-right: 0;
  }
</style>